import { FormInstance } from "antd";

export const handleCaculatorForCyl = (
  index: number,
  form: FormInstance,
  side: string,
  value: any,
  name: string
) => {
  if (index === 0) {
    const valueSph = parseFloat(
      form.getFieldValue([name, side, "tb1", "sph", 1])
    );

    if (valueSph || valueSph === 0) {
      const valueUp = parseFloat(
        form.getFieldValue([name, side, "tb1", "cyl", 0])
      );
      const valueDown = isNaN(valueUp)
        ? ""
        : `${valueUp >= 0 ? "+" : ""}${valueUp.toFixed(2).toString()}`;

      form.setFieldValue([name, side, "tb1", "cyl", 2], valueDown);
    }
  } else form.setFieldValue([name, side, "cyl", 2], value);

  if (!value) {
    form.setFieldValue([name, side, "tb1", "cyl", 2], "");
  }
};
export const handleCaculatorForAxis = (
  index: number,
  form: FormInstance,
  side: string,
  value: any,
  name: string
) => {
  if (index === 0) {
    const valueSph = parseFloat(
      form.getFieldValue([name, side, "tb1", "sph", 1])
    );

    if (valueSph || valueSph === 0) {
      const valueUp = parseFloat(
        form.getFieldValue([name, side, "tb1", "axis", 0])
      );
      const valueDown = isNaN(valueUp)
        ? ""
        : isNaN(valueUp)
        ? null
        : Math.abs(valueUp).toString();

      form.setFieldValue([name, side, "tb1", "axis", 2], valueDown);
    }
  } else form.setFieldValue([name, side, "axis", 2], value);

  if (!value) {
    form.setFieldValue([name, side, "tb1", "axis", 2], "");
  }
};

export const handleCaculatorForSph = (
  index: number,
  form: FormInstance,
  side: string,
  value: any,
  name: string
) => {
  if (index === 0) {
    const valueUp = parseFloat(
      form.getFieldValue([name, side, "tb1", "sph", 1])
    );
    const sum = valueUp + parseFloat(value);

    const valueTotal =
      isNaN(valueUp) || isNaN(value) || isNaN(sum)
        ? ""
        : parseFloat(value)
        ? isNaN(sum)
          ? ""
          : `${sum > 0 ? "+" : ""}${sum.toFixed(2).toString()}`
        : `${valueUp > 0 ? "+" : ""}${valueUp.toFixed(2).toString()}`;
    form.setFieldValue([name, side, "tb1", "sph", 2], valueTotal);
    if (!value && !valueUp) {
      form.setFieldValue([name, side, "tb1", "sph", 2], null);
    }
  } else if (index === 1) {
    const valueUp = parseFloat(
      form.getFieldValue([name, side, "tb1", "sph", 0])
    );
    const valueDown = parseFloat(
      form.getFieldValue([name, side, "tb1", "sph", 1])
    );

    const valueCyl = parseFloat(
      form.getFieldValue([name, side, "tb1", "cyl", 0])
    );

    const valueAxis = parseFloat(
      form.getFieldValue([name, side, "tb1", "axis", 0])
    );

    const sum = valueUp + parseFloat(value);
    // Kiểm tra nếu dữ liệu sph1 và sph0 có dữ liệu thì cho tính
    if ((valueDown || valueDown === 0) && valueUp) {
      const valueTotal = isNaN(sum)
        ? null
        : `${sum > 0 ? "+" : ""}${sum.toFixed(2).toString()}`;
      form.setFieldValue([name, side, "tb1", "sph", 2], valueTotal);
      // Kiểm tra xem Cyl có dữ liệu hay không?
      const valueTotalCyl = isNaN(valueCyl)
        ? null
        : `${valueCyl >= 0 ? "+" : ""}${valueCyl.toFixed(2).toString()}`;

      form.setFieldValue([name, side, "tb1", "cyl", 2], valueTotalCyl);

      // Kiểm tra xem Axis có dữ liệu hay không?
      const valueTotalAxis = isNaN(valueAxis)
        ? null
        : Math.abs(valueAxis).toString();

      form.setFieldValue([name, side, "tb1", "axis", 2], valueTotalAxis);
    } else {
      // Kiểm tra xem sph1 có dữ liệu hay không

      if (value || value === 0) {
        const valueTotal = isNaN(valueDown)
          ? null
          : `${valueDown >= 0 ? "+" : ""}${valueDown.toFixed(2).toString()}`;

        form.setFieldValue([name, side, "tb1", "sph", 2], valueTotal);

        // Kiểm tra xem Cyl có dữ liệu hay không?
        const valueTotalCyl = isNaN(valueCyl)
          ? null
          : `${valueCyl >= 0 ? "+" : ""}${valueCyl.toFixed(2).toString()}`;

        form.setFieldValue([name, side, "tb1", "cyl", 2], valueTotalCyl);

        // Kiểm tra xem Axis có dữ liệu hay không?
        const valueTotalAxis = isNaN(valueAxis)
          ? null
          : Math.abs(valueAxis).toString();

        form.setFieldValue([name, side, "tb1", "axis", 2], valueTotalAxis);
      }
      // Kiểm tra nếu sph1 k có dữ liệu thì clear hết data
      else {
        form.setFieldValue([name, side, "tb1", "cyl", 2], null);
        form.setFieldValue([name, side, "tb1", "sph", 2], "");
        form.setFieldValue([name, side, "tb1", "axis", 2], null);
      }
    }
  } else form.setFieldValue([name, side, "sph", 2], value);
};
